export default [
  {
    path: '/company/history-companies/',
    name: 'company-history-companies',
    component: () =>
        import(/* webpackChunkName: "company" */ '@/components/companies/history_companies/HistoryCompanies.vue')
  },
  {
    path: '/company/positions/',
    name: 'company-positions',
    component: () =>
        import(/* webpackChunkName: "company" */ '@/components/companies/positions/Positions.vue')
  },
  {
    path: '/company/questions/',
    name: 'company-questions',
    component: () =>
        import(/* webpackChunkName: "company" */ '@/components/companies/questions/Questions.vue')
  },
  {
    path: '/company/locations/',
    name: 'company-locations',
    component: () =>
        import(/* webpackChunkName: "company" */ '@/components/companies/locations/Locations.vue')
  },
  {
    path: '/company/educations/',
    name: 'company-educations',
    component: () =>
        import(/* webpackChunkName: "company" */ '@/components/companies/educations/Educations.vue')
  },
  {
    path: '/company/texts/',
    name: 'company-texts',
    component: () =>
        import(/* webpackChunkName: "company" */ '@/components/companies/texts/Texts.vue')
  },
  {
    path: '/company/meetings/',
    name: 'company-meetings',
    component: () =>
        import(/* webpackChunkName: "company" */ '@/components/companies/meetings/Meetings.vue')
  }
]
